import Vue from 'vue';
import inputmask from 'inputmask';

// Register a global custom directive called v-focus
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted(el) {
    // Focus the element
    el.focus();
  }
});

Vue.directive('mask', {
  bind(el, binding) {
    if (binding.value) inputmask(binding.value).mask(el);
  }
});

Vue.filter('capitalize', value => {
  if (!value) return '';
  return value
    .toString()
    .replace(/[A-zÀ-ú0-9]\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
});

Vue.filter('lowercase', value => {
  if (!value) return '';
  return value.toString().toLowerCase();
});

Vue.filter('uppercase', value => {
  if (!value) return '';
  return value.toString().toUpperCase();
});

Vue.filter('first-letter', value => {
  if (!value) return '';
  return (
    value
      .toString()
      .charAt(0)
      .toUpperCase() + value.toString().slice(1)
  );
});

Vue.filter('trim-and-uppercase', value => {
  if (!value) return '';
  return value
    .replace(/\s/g, '')
    .trim()
    .toUpperCase();
});
